import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import BannerForm from "./components/form";
import Service from "../../services/brandCategoryService";
import ProductService from "../../services/productService";
import $ from "jquery";
// import store from "store";

class CreateBanner extends Component {
  state = {
    infoData: {},
    productList: [],
  };
  componentWillMount() {
    this.setState({ loader: true }, function () {
      // this.callApiProductInfo();
      Service.fetchBrandCategoryInfo().then((response) => {
        // if (!response.error) {
        //   this.setState({ brandsList: response.brandList });
        //   this.setState({ categoryList: response.categoryList });
        // }
        if (!response.error) {
          this.setState({
            modalFormShow: false,
            loader: false,
            productList: response?.data?.categoryList,
          });
        } else {
          this.setState({
            modalFormShow: false,
            loader: false,
            productList: [],
          });
        }
      });
    });
  }
  callApiProductInfo = () => {
    ProductService.fetchProductList().then((response) => {
      if (!response.error) {
        this.setState({
          modalFormShow: false,
          loader: false,
          productList: response?.data?.productList,
        });
      } else {
        this.setState({
          modalFormShow: false,
          loader: false,
          productList: [],
        });
      }
    });
    this.setState({ loader: false });
  };
  addBannerForm = (data) => {
    const { isEdit, info, imageUrl, selectedProductId } = this.state;
    this.setState({ loader: true });
    data["imageUrl"] = imageUrl;
    data["bannerImageId"] = isEdit ? info._id : undefined;
    data["productId"] = selectedProductId;
    var method = isEdit ? "PUT" : "POST";
    Service.addBannerImageInfo(data, method).then((response) => {
      if (!response.error) {
        // this.callApiInfo();
        this.props.history.push("/banners/all");
      }
    });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  render() {
    const {
      bannerImageId,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
      productList,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;

    const bannerFormProps = {
      productList: productList,

      // onChangeProductId: this.onChangeProductId,
      onChangeProductId: (bannerImageId) => {
        this.setState({ selectedProductId: bannerImageId });
      },
      imageUrl: imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      info: infoData || {},
      active: this.state.active,
      onChangeProductUrl: (e) => {
        console.log({ e });
      },
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeBannerId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addBannerForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      // BannerForm: infoData,
    };
    return (
      <Fragment>
        <Breadcrumb title={"Add"} parent="Banner" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)", padding:"30px"}}>
                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}

                <BannerForm {...bannerFormProps} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateBanner;
